<template>
  <slot name="returnInfo"></slot>
  <div class="content_detail">
    <div class="game_info">
      <van-skeleton
        title
        avatar
        avatar-shape="square"
        :row="1"
        :loading="!props.loadFlag"
      >
        <img :src="props.pic1" alt="" />
      </van-skeleton>
      <h1>{{ props.gamename }}</h1>
    </div>

    <div
      class="no_return"
      v-if="(!props.is_pay || props.is_gq) && !props.is_hs"
    >
      <p>
        <span>首笔充值时间</span>
        <span v-if="props.is_gq">{{ timestampToTime(props.create_time) }}</span>
        <span v-else>暂未充值</span>
      </p>
      <p>
        <span>申请截止时间</span>
        <span v-if="props.is_gq">{{ timestampToTime(props.end_time) }}</span>
        <span v-else>首充后两小时内</span>
      </p>
    </div>

    <div v-if="(props.is_pay && !props.is_gq) || props.is_hs">
      <div class="order_info" v-if="!state.detailFlage">
        <p class="return_limit">
          <span>可退余额</span>
          <span>{{ props.tkmoney }}</span>
        </p>
        <p class="open_detail" @click="openDetail">
          查看明细
          <img src="../../../../assets/game/return_detail_open.png" alt="" />
        </p>
      </div>

      <transition name="order-info">
        <div class="order_detail" v-if="state.detailFlage" ref="orderDetail">
          <div class="title">
            充值明细
            <span>(不包括优惠券、月卡、赠送余额等优惠)</span>
          </div>
          <div class="account_detail" v-if="props.paylists.length > 0">
            <p v-for="(item, index) in props.paylists">
              <span>{{ item.nickname }}</span>
              <span>充值：{{ item.pay_money }}</span>
            </p>
          </div>
          <p class="all_order">
            <span>充值总额</span>
            <span>{{ props.paymoney }}</span>
          </p>
          <p class="return_percent">
            <span> 退还比例 </span>
            <span> {{ props.thbl }} </span>
          </p>
          <div class="return_money">
            <span>可退余额</span>
            <span>{{ props.tkmoney }}</span>
          </div>
        </div>
      </transition>
    </div>
  </div>

  <div class="no_return2" v-if="(props.is_pay && !props.is_gq) || props.is_hs">
    <p>
      <span>首笔充值时间</span>
      <span>{{ timestampToTime(props.create_time) }}</span>
    </p>
    <p>
      <span>申请截止时间</span>
      <span>{{ timestampToTime(props.end_time) }}</span>
    </p>
    <p>
      <span>小号回收</span>
      <span>您有充值的小号将被回收</span>
    </p>
  </div>
</template>
<script setup>
import { onActivated } from "vue";
import { ref, watch, reactive, onDeactivated } from "vue";
import { timestampToTime } from "@/utils/date";

const state = reactive({
  detailFlage: false,
});

const props = defineProps({
  gamename: {
    type: String,
    default: "",
  },
  pic1: {
    type: String,
    default: "",
  },
  is_pay: {
    type: Boolean,
    default: false,
  },
  tkmoney: {
    type: Number,
    default: 0,
  },
  paylists: {
    type: Array,
    default: () => [],
  },
  paymoney: {
    type: Number,
    default: 0,
  },
  thbl: {
    type: String,
    default: "",
  },
  create_time: {
    type: Number,
    default: 0,
  },
  end_time: {
    type: Number,
    default: 0,
  },
  is_gq: {
    type: Boolean,
    default: false,
  },
  is_hs: {
    type: Boolean,
    default: false,
  },
  loadFlag: {
    type: Boolean,
    default: false,
  },
});

watch(props, (newVal, oldVal) => {
  // console.log("props内的数据变化了", newVal);
});

const orderDetail = ref(null);

const openDetail = () => {
  state.detailFlage = true;
  // 添加一个高度渐渐变大的效果
  setTimeout(() => {
    orderDetail.value.style.maxHeight = "2000px";
  }, 0);
};

onDeactivated(() => {
  state.detailFlage = false;
});
</script>
<style scoped>
.content_detail {
  width: 686px;
  /* min-height: 298px; */
  background-color: #fff;
  border-radius: 24px;
  padding: 32px;
}
.content_detail .game_info {
  display: flex;
  align-items: center;
  padding-bottom: 24px;
  border-bottom: 2px dashed #f1f1f1;
}
.content_detail .game_info img,
.game_info :deep(.van-skeleton__avatar) {
  width: 112px;
  height: 112px;
  border-radius: 24px;
  margin-right: 0;
}

.game_info :deep(.van-skeleton) {
  padding: 0;
}
.content_detail .game_info h1 {
  font-size: 28px;
  margin-left: 24px;
  color: #333;
}

.content_detail .no_return p {
  display: flex;
  justify-content: space-between;
  font-size: 24px;
  margin-top: 24px;
  color: #333;
}
.content_detail .no_return p span:nth-of-type(2) {
  color: #999999;
}

.return_limit {
  display: flex;
  justify-content: space-between;
  color: #333;
}
.return_limit span:nth-of-type(2) {
  color: #12cec7;
}
.open_detail {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  color: #999999;
}
.open_detail img {
  width: 26px;
  height: 26px;
}

.order_detail {
  margin-top: 24px;
  max-height: 30px;
  overflow: hidden;
  transition: max-height 1.5s ease-in-out;
  color: #333;
}
.order_detail p {
  font-size: 24px;
}

.order_detail .title {
  color: #333;
  font-size: 24px;
}
.order_detail .title span {
  color: #999999;
}
.order_detail .account_detail {
  width: 622px;
  padding: 28px 32px;
  padding-bottom: 1px;
  border-radius: 26px;
  background-color: #f1f1f1;
  margin: 24px 0;
  font-size: 24px;
  color: #333;
}
.order_detail .account_detail p {
  margin-bottom: 24px;
}
.order_detail .account_detail p,
.all_order,
.return_percent,
.return_money {
  display: flex;
  justify-content: space-between;
}
.return_percent {
  margin-top: 24px;
}
.return_money {
  font-size: 24px;
  border-top: 2px solid #f1f1f1;
  padding-top: 28px;
  margin-top: 24px;
}
.return_money span:nth-of-type(2) {
  color: #12cec7;
  font-weight: 900;
}
.order_info {
  margin-top: 24px;
}

.no_return2 {
  background-color: #fff;
  width: 686px;
  height: 214px;
  border-radius: 24px;
  padding: 32px;
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.no_return2 p {
  display: flex;
  justify-content: space-between;
  font-size: 24px;
}
.no_return2 p span:nth-of-type(2) {
  color: #999999;
}
</style>
